import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { OtherError } from "./OtherError";
export function EduidError({ errorURL }) {
    // saml_response_unsolicited means the SAML response did not establish a session either, so it
    // gets the same message as saml_response_fail.
    if (errorURL.rp === "authn" &&
        (errorURL.ctx === "saml_response_fail" || errorURL.ctx === "saml_response_unsolicited")) {
        return _jsx(NotLoggedIn, {});
    }
    return _jsx(OtherError, {});
}
function NotLoggedIn() {
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "eduidError.heading", defaultMessage: "Not logged in", description: "ErrorURL eduid error" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "eduidError.body", defaultMessage: "You are not logged in, or the session expired.", description: "ErrorURL eduid error" }) })] }));
}
